import {FlexGrid, FormatItemEventArgs} from "@mescius/wijmo.grid";
import {ColorMap} from "./color-map";
import {CollectionView} from "@mescius/wijmo";
import {WjGridUtils} from './wjgrid-utils';

export class WjGridHeatmapCol {

    private min: number = Number.POSITIVE_INFINITY;
    private max: number = Number.NEGATIVE_INFINITY;
    private valueRange = NaN;

    constructor(private grid: FlexGrid, private binding: string, private colorMap: ColorMap, private autoMinMax: boolean = false) {
        grid.formatItem.addHandler(this.heatMapFormatHandler.bind(this));
        if (autoMinMax) {
            this.findMinMax();
            grid.loadedRows.addHandler(() => this.findMinMax());
            grid.itemsSourceChanged.addHandler(() => this.findMinMax());
        }
    }

    private getGridData(): any[] {
        const itemsSource = this.grid.itemsSource;
        if (Array.isArray(itemsSource)) return itemsSource;
        else if (itemsSource instanceof CollectionView) return itemsSource.sourceCollection;
        else return [];
    }

    private findMinMax() {
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;

        const data = this.getGridData();
        for (const row of data) {
            const value = row[this.binding];
            if (typeof value === 'number') {
                min = Math.min(min, value);
                max = Math.max(max, value);
            }
        }

        this.min = min;
        this.max = max;
        this.valueRange = (max > min) ? max - min : NaN;
    }

    private heatMapFormatHandler(s: FlexGrid, e: FormatItemEventArgs) {
        const isInputElement = WjGridUtils.hasAnyInputChildElement(e.cell);
        if (isInputElement) return;

        if (e.panel === s.columnHeaders) {
        } if (e.panel === s.cells) {
            // console.log(`$heatMapFormatHandler: ${e.row}, ${e.col}, ${e.getColumn().binding}`)
            if (e.getColumn().binding === this.binding){
                // mark the cell as 'styled as a heatmap cell'
                e.cell.classList.toggle('heatmap-cell', true)

                const value = s.getCellData(e.row, e.col, false);
                if (typeof value !== 'number') {
                    e.cell.style.backgroundColor = '';
                } else {
                    const colorValue = this.autoMinMax ? this.valueRelativeToMinMaxInterval(value) : value;
                    const color = this.colorMap.interpolateColor(colorValue);
                    e.cell.style.backgroundColor = color;
                }
            }
        }
    }

    private valueRelativeToMinMaxInterval(value: number): number {
        return (value - this.min) / this.valueRange;
    }

    static addHeatmapColumn(grid: FlexGrid, binding: string, colorMap: ColorMap, autoMinMax: boolean = false): WjGridHeatmapCol {
        return new WjGridHeatmapCol(grid, binding, colorMap, autoMinMax);
    }

}
